'use client';
import type { TokenSizeProps } from '@mnd-frontend/icons/utils/type';
import { RED_700, SIZING_6 } from '@mnd-frontend/ui/shared/tokens';
import type { ComponentType } from 'react';
import styled from 'styled-components';

const Container = styled.span<{ $color: string }>`
  display: grid;
  align-items: center;
  justify-content: center;
  background: ${({ $color }) => $color};
  border-radius: 50%;
  color: #FFFFFF;
  flex-shrink: 0;
  height: ${SIZING_6};
  width: ${SIZING_6};
  pointer-events: none;
`;

const IconBadge = ({
  icon: Icon,
  color = RED_700,
}: {
  icon: ComponentType<TokenSizeProps>;
  color?: string;
}) => {
  return (
    <Container $color={color}>
      <Icon $size="xs" />
    </Container>
  );
};

export default IconBadge;
